export const iconButtonStyles = {
  padding: '10px 14px',
  textDecoration: 'none !important',
  textTransform: 'none',
  color: ({ palette }) => `${palette.common.white} !important`,
  font: ({ typography }) => typography.medium16,
  height: 'unset',

  '&[data-is-active="true"]': {
    backgroundColor: ({ palette }) => `${palette.primary.dark} !important`,
  },
};
